import { renderAmplienceSlotComponents } from '@storefront/lib-global';
import { PLPAmplienceComponents } from '../plpAmplienceComponents';
import { SlotAndDescription } from './SlotAndDescription';
import type { SlotAndDescriptionProps } from './SlotAndDescription';

const AmplienceComponents = {
  ...PLPAmplienceComponents,
};

export function SlotContentPLP({
  isDesktop,
  slotContent,
  handlebarComponents,
  categoryDescription,
  locale,
}: SlotAndDescriptionProps) {
  if (isDesktop) {
    return slotContent ? (
      <>{renderAmplienceSlotComponents(slotContent.pageContent, AmplienceComponents, handlebarComponents, locale)}</>
    ) : null;
  }

  return (
    <SlotAndDescription
      slotContent={slotContent}
      handlebarComponents={handlebarComponents}
      categoryDescription={categoryDescription}
      isPLP
      isDesktop={isDesktop}
    />
  );
}
